module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAOBJREFUSEu9lrERwjAMRb96ppEXogsdFIxBAUcDHQs5y0BvzrnAmWBbchwnVS5O/pPkr8jEzFcAWwDHvu/vWOBi5g7ACcCDmPlJRJtR92CtvdQwjDF7AGev4Zx7eUBHRLdAdDYkFB8BO/I30wUAxZCUxgCoheQC/ALmQqTsfwClEEnc6/0BtBCNeBIgQbTiWUAKMnpi8Lmmd6IlChstEm24LNpZBCQy8Y9FcbFEmR5ZDtC0RDG3LLbJOStW21QjoHknusnaD6Vm/BhkvZ9dSeRhp0mZtB84zUfmGkO/6bHlDaOgz3dQJgAqAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/imgs/login/close.png
// module id = olQK
// module chunks = 0